import {useEffect, useCallback, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FetchStatusType} from '@stencil/hotels-types/src/details-types';
import {IUpdate_Query, UPDATE_QUERY} from '@stencil/hotels-common-reducer/src/types';
import {
  fetchPokusDataStatusSelectorFn,
  destinationSelectorFn,
  pokusAutosuggestExpValueSelectorFn,
  pokusAutosuggestChildExpValueSelectorFn,
} from '@stencil/hotels-common-reducer/src/selectors';
import {getNewAutoSuggestUrl} from '@stencil/hotels-utils/src/autoSuggest-utils/getAutoSuggestUrl';
import {updateAutoSuggestSelection} from '@stencil/hotels-utils/src/autoSuggest-utils/parser';
import {getPlacesId} from '@stencil/hotels-utils/src/get-places-id';

const useNewAutoSuggestLoad = ({flavour = 'mweb', data = []}) => {
  const dispatch = useDispatch();
  const pokusDataStatus = useSelector(fetchPokusDataStatusSelectorFn);
  const autosuggestExpValue = useSelector(pokusAutosuggestExpValueSelectorFn);
  const autosuggestChildExpValue = useSelector(pokusAutosuggestChildExpValueSelectorFn);
  const [isApiLoading, setIsApiLoading] = useState(null);
  const [isResultFetched, setIsResultFecthed] = useState(null);

  const destination = useSelector(destinationSelectorFn);

  const updateQueryCaller = useCallback(
    (actionData: IUpdate_Query['actionData']) => {
      return dispatch({type: UPDATE_QUERY, actionData});
    },
    [dispatch],
  );

  const setSelectedDestination = async (resp = []) => {
    let arr = resp.filter(item => item?.voyId == destination?._id);
    console.log('ARR::', arr);
    if (arr && Array.isArray(arr) && arr.length) {
      let updatedSuggestion = updateAutoSuggestSelection(arr[0]) || {};
      if (!updatedSuggestion?._id) {
        try {
          updatedSuggestion = await getPlacesId(updatedSuggestion);
        } catch (err) {
          console.error(err);
        }
      }
      const updateObj = {
        destination: {...destination, ...updatedSuggestion},
      };
      updateQueryCaller(updateObj);
    }

    setIsResultFecthed(true);
  };

  const fetchVoyagerNewLocationSuggestions = useCallback(async () => {
    let search_query = destination?.n;
    const fetchVoyagerUrlForInput = getNewAutoSuggestUrl({
      search_query,
      exps: autosuggestExpValue,
      expKey: autosuggestChildExpValue,
    });

    if (!search_query || !fetchVoyagerUrlForInput) {
      return [];
    }
    setIsResultFecthed(false);
    setIsApiLoading(true);
    const res = await fetch(fetchVoyagerUrlForInput);

    if (!res.ok) throw new Error(res.statusText);
    const ret = await res.json();
    if (ret && ret.length) {
      setSelectedDestination(ret);
    }
    setIsApiLoading(false);
    setIsResultFecthed(true);
  }, [getNewAutoSuggestUrl, autosuggestExpValue]);

  useEffect(() => {
    const isPokusDataResolvedorRejected =
      pokusDataStatus === FetchStatusType.RESOLVED || pokusDataStatus === FetchStatusType.REJECTED;
    // console.log('isNewAutoSuggestPokus::', mwebNewAutoSuggestVal);
    if (
      isPokusDataResolvedorRejected &&
      !destination?.contextId &&
      isApiLoading == null &&
      !isApiLoading &&
      isResultFetched == null &&
      !isResultFetched
    ) {
      if (flavour == 'mweb') {
        fetchVoyagerNewLocationSuggestions();
      } else if (data?.length > 0 && destination?.contextId) {
        setSelectedDestination(data);
      }
    }

    // if (flavour == 'dweb' && isNewAutoSuggestPokus && !destination?.contextId && data?.length > 0) {

    // }
  }, [pokusDataStatus, data]);
};

export default useNewAutoSuggestLoad;
